import styled, { css } from "styled-components"
import { colors } from "../colors/color";
import { PStyling, SmallStyling } from "../styles/typography";

export type bodyColors = 'neutral' | 'default' | 'white' | 'error';

export const handlebodyColor = (color: bodyColors) => {
    switch (color) {
        case "neutral":
            return `${colors.text.gray.dark}`;
        case "default":
            return `${colors.text.gray.dark}`;
        case "white":
            return `white`;
        case "error":
            return `${colors.text.state.error}`;
        default:
            return `${colors.text.gray.dark}`;
    }
};



export const bodyShared = css`
    font-family: 'Noto Sans', sans-serif;
    font-size:16px;
    font-weight: 300;
    letter-spacing: 0.5px;
    line-height: 1.4;
    margin: 0;
    color: ${colors.text.gray.dark};
`

export const P = styled.p<{ color?:bodyColors, verticalMargin?:string, fontSize?:string, paddingTop?:boolean }>`
    ${PStyling}
    ${props => props.paddingTop && 'padding-top: 10px'};
`;

export const Strong = styled.strong<{color?:bodyColors}>`
    font-size: 16px;
    font-weight: 600;
`;

export const Small = styled.small<{color?:bodyColors, variant?:'neutral'|'normal'}>`
    ${SmallStyling}
`;